import { Badge, Button, Popover, Stack, Text } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { UploadProgress } from './UploadProgress';
import { useUploads } from './context';

/** Header button listing uploads in flight; uploads continue while you move around the admin. */
export function UploadsIndicator() {
  const { uploads } = useUploads();
  if (uploads.length === 0) return null;
  const active = uploads.filter((u) => u.phase === 'uploading' || u.phase === 'creating').length;
  return (
    <Popover width={340} position="bottom-end" withinPortal shadow="md">
      <Popover.Target>
        <Button
          variant="default"
          size="xs"
          leftSection={<IconUpload size={14} />}
          rightSection={
            active ? (
              <Badge size="xs" circle>
                {active}
              </Badge>
            ) : undefined
          }
        >
          Uploads
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="md">
          <Text size="xs" c="dimmed">
            Keep this tab open until uploads finish. You can carry on working meanwhile.
          </Text>
          {uploads.map((u) => (
            <UploadProgress key={u.key} upload={u} />
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
